var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
//import {CommonParams, ThreeManager} from "~/assets/ts/three/ThreeManager";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { makePromisePack } from "../../../../ts/lib/promise/PromisePack";
import { BufferGeometryUtil } from "../../../three/utils/BufferGeometryUtil";
var GLTFBase = /** @class */ (function () {
    function GLTFBase(params, $name) {
        var _this = this;
        this._onPreRender = function () {
            if (!_this.mesh)
                return;
            _this.atPreRender();
        };
        this.manager = params.manager;
        this.materials = params.materials;
        this.name = $name;
        this.manager.on('preRender', this._onPreRender);
    }
    GLTFBase.load = function (path) {
        return __awaiter(this, void 0, void 0, function () {
            var pp, loader;
            var _this = this;
            return __generator(this, function (_a) {
                pp = makePromisePack();
                loader = new GLTFLoader();
                loader.load(path, function (gltf) {
                    _this.gltf = gltf;
                    pp.resolve();
                });
                return [2 /*return*/, pp.promise];
            });
        });
    };
    // 複数のメッシュをひとつに統一
    //
    // 1. 色の違いだけなら、頂点カラーを設定してマテリアルもひとつにまとめる
    // materialIndices は渡さない
    //
    // 2. スペキュラーの有無などでマテリアルを分けたいなら、複数マテリアルを使用する（頂点カラーは必要ない）
    // materialIndices を渡す
    GLTFBase.merge = function (meshes, materialIndices) {
        var geometries = meshes.map(function (m) { return m.geometry; });
        var geometry;
        // GLTFのマテリアルからカラーを抽出
        var colors = meshes.map(function (m) { return m.material.color; });
        // 単一マテリアルの場合は頂点カラーを使用する
        if (!materialIndices) {
            // マテリアルから色を抽出して頂点に適用
            geometries.forEach(function (geometry, i) {
                BufferGeometryUtil.setSingleColor(geometry, colors[i]);
            });
            // メッシュ結合
            geometry = BufferGeometryUtil.merge(geometries, {
                names: ['position', 'normal', 'uv', 'color'],
                itemSizes: [3, 3, 2, 3]
            });
            // マルチマテリアルの場合は頂点カラーは使用しない
        }
        else {
            // メッシュ結合
            geometry = BufferGeometryUtil.merge(geometries, {
                names: ['position', 'normal', 'uv'],
                itemSizes: [3, 3, 2]
            }, materialIndices);
        }
        this.geometry = geometry;
    };
    GLTFBase.prototype.destroy = function () {
        this.manager.off('preRender', this._onPreRender);
    };
    GLTFBase.prototype.atPreRender = function () { };
    return GLTFBase;
}());
export { GLTFBase };
